import React from "react";

import { Menu, MenuItem, Typography } from "@mui/material";
import { QuickViewDeleteIcon, QuickViewEditIcon } from "assets/material-custom-icons";
import { QuickViewTableColumn } from "store/types";

interface Props {
  item: QuickViewTableColumn;
  deleteColumn: (item: QuickViewTableColumn) => void;
  openCustomMenu: (e: HTMLElement | null) => void;
  container?: Element | null;
}

export const SmartSheetColumnMenu: React.FC<
  Props & {
    anchorEl: HTMLElement | null;
    onClose: () => void;
  }
> = ({ item, deleteColumn, openCustomMenu, anchorEl, onClose, container }) => {
  const open = Boolean(anchorEl);

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose} container={container ?? document.body}>
      <MenuItem
        onClick={() => {
          openCustomMenu(anchorEl);
          onClose();
        }}
      >
        <QuickViewEditIcon sx={{ mr: 1 }} />
        <Typography>Edit</Typography>
      </MenuItem>

      <MenuItem
        onClick={() => {
          deleteColumn(item);
          onClose();
        }}
      >
        <QuickViewDeleteIcon sx={{ mr: 1 }} />
        <Typography>Delete</Typography>
      </MenuItem>
    </Menu>
  );
};
